<!-- Dialog element for modal view -->
<dialog
	#dialog
	[attr.aria-label]="
		cookieBannerData ? (showCookiesSettings ? cookieBannerData.settings.title : cookieBannerData.title) : null
	"
>
	<!-- Card dialog content  -->
	<div class="dialog-content">
		<!-- Cookie banner content -->
		<div
			class="card banner p-3"
			*ngIf="!showCookiesSettings; else cookiesSettings"
		>
			<!-- Language translate button -->
			<div
				class="col-4 align-self-end text-end"
				*ngIf="isMultiLingual"
			>
				<div class="btn-group">
					<!-- DE language -->
					<input
						type="radio"
						class="btn-check"
						id="cookieDeBtn"
						autocomplete="off"
						[(ngModel)]="selectedLanguage"
						(ngModelChange)="translationService.translate(EnumLanguage.DE)"
						[value]="EnumLanguage.DE"
						[checked]="selectedLanguage === EnumLanguage.DE"
					/>
					<label
						class="btn mb-0"
						[ngClass]="selectedLanguage === EnumLanguage.DE ? 'btn-primary text-white' : 'btn-white'"
						for="cookieDeBtn"
					>
						DE
					</label>

					<!-- EN language -->
					<input
						type="radio"
						class="btn-check"
						id="cookieEnBtn"
						autocomplete="off"
						[(ngModel)]="selectedLanguage"
						(ngModelChange)="translationService.translate(EnumLanguage.EN)"
						[value]="EnumLanguage.EN"
						[checked]="selectedLanguage === EnumLanguage.EN"
					/>
					<label
						class="btn mb-0"
						[ngClass]="selectedLanguage === EnumLanguage.EN ? 'btn-primary text-white' : 'btn-white'"
						for="cookieEnBtn"
					>
						EN
					</label>
				</div>
			</div>

			<div class="d-md-flex w-100 cookie-banner-main">
				<!-- Decorative cookie icon -->
				<div
					class="col-12 col-md-2 d-flex justify-content-center align-items-center cookie-banner-illustration"
				>
					<svg
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="1.75"
						stroke-linecap="round"
						stroke-linejoin="round"
						aria-hidden="true"
						focusable="false"
					>
						<path d="M21 12a9 9 0 1 1-9-9 4 4 0 0 0 4 4 4 4 0 0 0 5 5Z" />
						<circle
							cx="8"
							cy="8"
							r="0.75"
							fill="currentColor"
							stroke="none"
						/>
						<circle
							cx="7"
							cy="14"
							r="0.75"
							fill="currentColor"
							stroke="none"
						/>
						<circle
							cx="12"
							cy="12"
							r="0.75"
							fill="currentColor"
							stroke="none"
						/>
						<circle
							cx="13"
							cy="17"
							r="0.75"
							fill="currentColor"
							stroke="none"
						/>
						<circle
							cx="17"
							cy="3"
							r="0.75"
							fill="currentColor"
							stroke="none"
						/>
						<circle
							cx="21"
							cy="7"
							r="0.75"
							fill="currentColor"
							stroke="none"
						/>
					</svg>
				</div>

				<!-- Cookies banner text -->
				<div
					class="col-sm-12 col-md-10 cookie-banner-copy"
					*ngIf="cookieBannerData"
				>
					<div
						class="d-flex justify-content-center justify-content-md-between align-items-center mb-2 pt-md-3"
					>
						<h2 class="text-center text-md-start mb-0">{{ cookieBannerData.title }}</h2>
					</div>

					<p
						class="info-text text-justify pe-md-2 scroll-bar"
						[innerHTML]="cookieBannerData.info | ngSafeHTML"
					></p>
				</div>
			</div>

			<!-- Cookies settings buttons -->
			<div
				class="d-md-flex w-100 cookie-banner-actions"
				*ngIf="cookieBannerData"
			>
				<div class="col-sm-12 col-md-2"></div>
				<div class="col-sm-12 col-md-10">
					<!-- Accept all settings -->
					<button
						class="btn btn-success col-12 col-md-auto my-2 m-md-2"
						(click)="acceptAll()"
						autofocus
					>
						<ng-fa-icon icon="check"></ng-fa-icon>
						{{ cookieBannerData.accept }}
					</button>

					<!-- Show cookies settings -->
					<button
						class="btn btn-light col-12 col-md-auto my-2 m-md-2 text-truncate"
						(click)="showCookiesSettings = true"
						[ngTooltip]="'Cookie Settings'"
						onlyTruncate
					>
						{{ cookieBannerData.settings.title }}
					</button>

					<!-- Deny all settings -->
					<button
						class="btn btn-light col-12 col-md-auto my-2 m-md-2 text-truncate"
						(click)="denyAll()"
						[ngTooltip]="cookieBannerData.consent"
						onlyTruncate
					>
						{{ cookieBannerData.consent }}
					</button>
				</div>
			</div>
		</div>
	</div>
</dialog>

<!-- Cookie settings modal template -->
<ng-template #cookiesSettings>
	<!-- Cookies banner content -->
	<div class="card banner p-3 p-md-5 cookie-settings-panel">
		<!-- Cookies settings component -->
		<legal-cookies-settings
			(socialMediaCookiesChange)="saveSocialMediaOptions($event)"
			(analyticalCookiesChange)="saveAnalyticsOptions($event)"
		></legal-cookies-settings>

		<div class="d-flex justify-content-between mt-3 cookie-settings-actions">
			<!-- Go back button -->
			<button
				class="btn btn-link text-gray"
				(click)="showCookiesSettings = false"
			>
				<ng-fa-icon
					class="me-2"
					icon="chevron-left"
					[fixedWidth]="false"
				></ng-fa-icon>
				{{ cookieBannerData.settings.back }}
			</button>

			<div class="d-flex">
				<!-- Save settings -->
				<button
					class="btn btn-light me-3"
					(click)="saveChanges()"
				>
					{{ cookieBannerData.settings.save }}
				</button>

				<!-- Accept all settings -->
				<button
					class="btn btn-success"
					(click)="acceptAll()"
				>
					<ng-fa-icon icon="check"></ng-fa-icon>
					{{ cookieBannerData.settings.accept }}
				</button>
			</div>
		</div>
	</div>
</ng-template>
